import { Link } from 'react-router-dom';

const footerLinks = {
  content: {
    title: '内容分类',
    links: [
      { label: '生活', path: '/category/shenghuo' },
      { label: '美食', path: '/category/meishi' },
      { label: '娱乐', path: '/category/yule' },
      { label: '创意', path: '/category/chuangyi' },
      { label: '音乐', path: '/category/yinyue' },
      { label: '旅行', path: '/category/lvxing' },
      { label: '科技', path: '/category/keji' },
      { label: '时尚', path: '/category/shishang' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '创作者入驻', path: '/about' },
      { label: '用户协议', path: '/about' },
      { label: '隐私政策', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
  help: {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/' },
      { label: '内容规范', path: '/about' },
      { label: '版权声明', path: '/about' },
      { label: '投诉建议', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl text-background-50 whitespace-nowrap">
                蜜桃视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              精选短视频内容平台，汇聚海量精彩视频资源。
              发现生活之美，记录精彩瞬间。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-background-700 transition-colors" rel="nofollow">
                <i className="ri-wechat-line text-background-300 text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-background-700 transition-colors" rel="nofollow">
                <i className="ri-weibo-line text-background-300 text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-background-700 transition-colors" rel="nofollow">
                <i className="ri-bilibili-line text-background-300 text-lg"></i>
              </a>
            </div>
          </div>

          {[footerLinks.content, footerLinks.about, footerLinks.help].map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-background-100 text-sm font-semibold mb-4">
                <a href={section.links[0].path} className="hover:text-background-50 transition-colors">{section.title}</a>
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 蜜桃视频 MitaoVideo.com 版权所有
          </p>
          <p className="text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">京ICP备2024000001号</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">京公网安备 11010000000001号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}